<template>
    <!-- 左对齐 -->
    <div
        style="width: 100%; height: 50%; position: absolute; bottom: 0; background-color: #fff; z-index: 99;"
    >
        <p class="title">内部污染报警：</p>
        <van-row
            type="flex"
            v-for="(alarm, index) in currentAlarmList"
            :key="alarm.id"
            class="row_style"
            :style="rowStyle(index, alarm)"
        >
            <van-col class="col_style" span="4">{{
                index + 1 + (currentPage - 1) * 10
            }}</van-col>
            <van-col class="col_style" span="14">{{
                alarm.update_time
            }}</van-col>
            <van-col
                class="col_style"
                style="color: #1890ff"
                span="6"
                @click="viewAlarm(alarm)"
                >查看</van-col
            >
        </van-row>
        <van-pagination
            class="pagination"
            v-model="currentPage"
            :total-items="alarmList.length"
            :show-page-size="3"
            force-ellipses
        />
        <van-empty
            v-if="alarmList.length === 0"
            image="error"
            description="此时间段无报警"
        />
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "AlarmList",
    data() {
        return {
            show: true,
            currentPage: 1,
            currentAlarm: ""
        };
    },
    computed: {
        ...mapState(["alarmList"]),
        currentAlarmList() {
            return this.alarmList.slice(
                (this.currentPage - 1) * 10,
                (this.currentPage - 1) * 10 + 10
            );
        }
    },
    methods: {
        rowStyle(index, alarm) {
            return {
                borderBottom: this.currentAlarmList.length > 10 ? (index === 9 && '1px solid #ccc') : (index === this.currentAlarmList.length -1 && '1px solid #ccc'),
                backgroundColor:
                    this.currentAlarm.id === alarm.id ? 'rgba(0,0,0, 0.1)' : ''
            }
        },
        viewAlarm(alarm) {
            this.currentAlarm = alarm;
            this.$emit("viewAlarm", alarm.update_time);
        }
    }
};
</script>

<style scoped>
.title {
    width: 90%;
    height: 24px;
    margin: 0 auto;
    font-size: 14px;
    line-height: 24px;
    font-weight: bold;
}
.row_style {
    width: 90%;
    height: 24px;
    line-height: 24px;
    margin: 0 auto;
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
}
.col_style {
    border-left: 1px solid #ccc;
    border-collapse: collapse;
    font-size: 14px;
    text-indent: 5px;
}
.pagination {
    font-size: 14px;
    position: absolute;
    bottom: 5px;
    right: 10px;
}
</style>
<style>
.pagination .van-pagination__item {
    min-width: 20px !important;
    height: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/application/virtual/AlarmList.vue